import * as XLSX from "xlsx";

// Excel cell values (serial numbers, Date objects or text) to a date at 12:00 UTC,
// so the calendar day stays the same in every time zone.

const isBlank = (value) =>
  value === null || value === undefined || value === "";

const makeUTCDate = (year, month, day) => {
  const date = new Date(Date.UTC(year, month - 1, day, 12, 0, 0));

  if (
    date.getUTCFullYear() !== year ||
    date.getUTCMonth() !== month - 1 ||
    date.getUTCDate() !== day
  ) {
    return null;
  }

  return date;
};

export const excelDateToDate = (value, date1904 = false) => {
  if (isBlank(value)) return null;

  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return makeUTCDate(
      value.getUTCFullYear(),
      value.getUTCMonth() + 1,
      value.getUTCDate(),
    );
  }

  if (typeof value === "number") {
    // Workbooks using the 1904 date system store serials 1462 days lower.
    const parsed = XLSX.SSF.parse_date_code(value, { date1904 });
    return parsed ? makeUTCDate(parsed.y, parsed.m, parsed.d) : null;
  }

  const text = String(value).trim();
  const dmy = text.match(/^(\d{1,2})[-/.](\d{1,2})[-/.](\d{2,4})$/);

  if (dmy) {
    let day = Number(dmy[1]);
    let month = Number(dmy[2]);
    let year = Number(dmy[3]);
    if (year < 100) year += 2000;

    // DD/MM is the default; a second part above 12 can only be MM/DD (e.g. 02/13/2026).
    if (month > 12 && day <= 12) {
      [day, month] = [month, day];
    }

    return makeUTCDate(year, month, day);
  }

  // Parse date-only ISO values from their components, not local time.
  const iso = text.match(/^(\d{4})[-/](\d{1,2})[-/](\d{1,2})(?:$|[T\s])/);
  if (iso) {
    return makeUTCDate(Number(iso[1]), Number(iso[2]), Number(iso[3]));
  }

  // Other text dates (e.g. "15-Jan-2026") are parsed as local dates, so read them back
  // with local getters; UTC getters would give the previous day in India.
  const parsed = new Date(text);
  if (Number.isNaN(parsed.getTime())) return null;

  return makeUTCDate(
    parsed.getFullYear(),
    parsed.getMonth() + 1,
    parsed.getDate(),
  );
};
